<template>
  <div>
    <div
      class="login-bg"
      v-bind:style="{ 'background-image': 'url(' + login_bg + ')' }"
    >
      <!--========================================================-->
      <div class="login-home-box">
        <img
          :src="
            require(`@/assets/images/${$store.state.app.switchProjectObj.img}`)
          "
          class="rongan_logo"
          style="
            margin-bottom: 30px;
            position: relative;
            left: 50%;
            transform: translateX(-50%);
            width: 100%;
            max-width: 150px;
          "
        />
        <div class="user-box">
          <input
            id="username"
            name="username"
            v-model="loginForm.username"
            placeholder=" "
            type="text"
            required=""
            @keyup.enter="HandleLogin"
          />
          <label>用户名</label>
        </div>
        <div class="user-box">
          <input
            id="password"
            name="password"
            :type="passwordType"
            v-model="loginForm.password"
            placeholder=" "
            required=""
            @keyup.enter="HandleLogin"
          />
          <label>密码</label>
          <span
            style="position: absolute; top: 10px; right: 0"
            class="cursorPointer"
            @click="passwordType = passwordType ? '' : 'password'"
          >
            <svg-icon
              style="color: #ffdb8b"
              :icon-class="passwordType ? 'th-eyeslash' : 'th-eye'"
              class="color-main"
            ></svg-icon>
          </span>
        </div>
        <div class="user-box">
          <input
            name="captcha"
            v-model="loginForm.captcha"
            placeholder=" "
            required=""
            @keyup.enter="HandleLogin"
          />
          <label>谷歌验证码</label>
        </div>

        <a
          href="javascript:;"
          @click="HandleLogin"
          :class="{ loading: loading }"
          ><span></span><span></span><span></span><span></span>登录</a
        >
      </div>
      <!--========================================================-->

      <!-- <img :src="login_center_bg" class="login-center-layout"> -->
      <el-dialog
        title="谷歌验证二维码"
        :visible.sync="dialogVisible"
        :show-close="false"
        :center="true"
        width="30%"
      >
        <div style="text-align: center">
          <!-- <span class="font-title-large"><span class="color-main font-extra-large">关注公众号</span>回复<span class="color-main font-extra-large">体验</span>获取体验账号</span>
        <br> -->
          <img
            :src="`data:image/png;base64, ${googleAuthenticatorQRCode}`"
            width="200"
            height="200"
            style="margin-top: 10px"
          />
        </div>
        <span slot="footer" class="dialog-footer">
          <el-button type="success" size="mini" @click="dialogConfirm"
            >关闭</el-button
          >
        </span>
      </el-dialog>
    </div>
    <!-- 通道型卡主弹框 -->
    <div
      v-if="$store.state.login.commonUserTypeDialog"
      class="dl-layout login-bg"
      :style="{ 'background-image': 'url(' + login_bg + ')' }"
    >
      <i class="el-icon-close close-btn cursorPointer" @click="clsoeDialog()" />
      <div class="content">
        <img :src="app_download" /><br /><br />请下载{{
          $store.state.app.switchProjectObj.title
        }}
        App 进行操作
      </div>
    </div>
    <div
      style="
        color: #fff;
        position: absolute;
        right: 10px;
        bottom: 10px;
        font-size: 18px;
      "
    >
      {{ ipAddress || "-" }}
    </div>
  </div>
</template>

<script>
import login_center_bg from "@/assets/images/login_center_bg.png";
import login_bg from "@/assets/images/1400x770-2.jpg";
// import rongan_logo from "@/assets/images/rongan.png";
import app_download from "@/assets/images/app_download.png";
import { getUserIp } from "@/api/user";

export default {
  name: "login",
  data() {
    return {
      loginForm: {
        username: null,
        password: null,
        captcha: null,
      },
      loading: false,
      passwordType: "password",
      login_center_bg,
      login_bg,
      // rongan_logo,
      app_download,
      dialogVisible: false,
      supportDialogVisible: false,
      googleAuthenticatorQRCode: null,
      downloadURL: null,
      ipAddress: null, // ip 位址
    };
  },
  created() {
    // 取得用户ip位址
    getUserIp().then((res) => {
      this.ipAddress = res.data;
    });
  },
  methods: {
    // 关闭通道型卡主弹框
    clsoeDialog() {
      location.reload();
    },
    showPwd() {
      if (this.passwordType === "password") {
        this.passwordType = "";
      } else {
        this.passwordType = "password";
      }
    },
    HandleLogin() {
      if (!this.loginForm.username) {
        return this.$notify.error("用户名不可为空");
      }
      const pattern = /^[a-zA-Z0-9~`!@#$%^&*()--+={}[\]|\\:;"'<>,.?/_]{3,}$/g;
      if (!this.loginForm.password || !pattern.test(this.loginForm.password)) {
        return this.$notify.error("密码为空或密码格式不符");
      }

      this.loading = true;
      this.passwordType = "password";
      this.$store
        .dispatch("Login", this.loginForm)
        .then((res) => {
          if (!res.data.token) {
            this.dialogVisible = true;
            this.googleAuthenticatorQRCode =
              res.data.verifyInfo.googleAuthenticatorQRCode;
            return;
          }
          this.$notify.success("登录成功");
          this.$router.push({ path: "/" });
        })
        .catch(() => {})
        .finally(() => {
          this.loading = false;
        });
    },
    handleTry() {
      this.dialogVisible = true;
    },
    dialogConfirm() {
      this.dialogVisible = false;
      // setSupport(true)
    },
    dialogCancel() {
      this.dialogVisible = false;
      // setSupport(false)
    },
  },
};
</script>

<style lang="scss" scoped>
.dl-layout {
  position: fixed;
  left: 0;
  top: 0;
  z-index: 3000;
  width: 100%;
  height: 100%;
  .close-btn {
    position: absolute;
    right: 30px;
    top: 30px;
    color: #fff;
    font-size: 35px;
  }
  .content {
    text-align: center;
    position: absolute;
    color: #fff;
    left: 50%;
    top: 50%;
    font-size: 20px;
    font-weight: 600;
    transform: translate(-50%, -50%);
  }
}
</style>
<style scoped>
/* Start 通道型卡主弹框 */
.login-bg /deep/ .el-dialog__title {
  color: #fff;
}
.login-bg /deep/ .el-dialog,
.el-pager li {
  background: rgba(0, 0, 0, 0.5);
}
/* End 通道型卡主弹框 */

.login-bg {
  justify-content: center;
  align-items: center;
  min-height: 100vh;
  background-size: cover;
  background-position: center;
}

.login-home-box {
  position: absolute;
  top: 50%;
  left: 50%;
  width: 80%;
  max-width: 400px;
  padding: 40px;
  transform: translate(-50%, -50%);
  background: rgba(0, 0, 0, 0.5);
  box-sizing: border-box;
  box-shadow: 0 15px 25px rgba(0, 0, 0, 0.6);
  border-radius: 4px;
  backdrop-filter: blur(3px);
}

.login-home-box .user-box {
  position: relative;
}

.login-home-box .user-box input {
  width: 100%;
  padding: 10px 0;
  font-size: 16px;
  color: #fff;
  margin-bottom: 30px;
  border: none;
  border-bottom: 1px solid #fff;
  outline: none;
  background: transparent;
  letter-spacing: 2px;
}
.login-home-box .user-box label {
  position: absolute;
  top: 0;
  left: 0;
  padding: 10px 0;
  font-size: 16px;
  color: #a9a9a9;
  pointer-events: none;
  transition: 0.5s;
}

.login-home-box .user-box.filled label,
.login-home-box .user-box input:valid ~ label,
.login-home-box .user-box input:-webkit-autofill ~ label {
  top: -20px;
  left: 0;
  color: #b8e9ff;
  font-size: 12px;
}

.login-home-box a {
  position: relative;
  display: inline-block;
  padding: 10px 20px;
  color: #b8e9ff;
  font-size: 16px;
  text-decoration: none;
  text-transform: uppercase;
  overflow: hidden;
  transition: 0.5s;
  margin-top: 40px;
  letter-spacing: 4px;
  left: 50%;
  transform: translateX(-50%);
}

.login-home-box a:hover {
  background: #b8e9ff;
  color: #fff;
  box-shadow: 0 0 5px #b8e9ff, 0 0 25px #b8e9ff, 0 0 50px #b8e9ff,
    0 0 100px #b8e9ff;
  -webkit-box-reflect: below -3px linear-gradient(transparent, #b8e9ff49);
}
.login-home-box a.loading {
  background: transparent;
  box-shadow: none;
  animation: box-shadow-ani 0.5s linear infinite;
}
@keyframes box-shadow-ani {
  0% {
    box-shadow: 0 0 5px #cdc1eb, 0 0 25px #cdc1eb, 0 0 50px #cdc1eb,
      0 0 100px #cdc1eb;
  }
  50%,
  100% {
    box-shadow: none;
  }
}

.login-home-box a span {
  position: absolute;
  display: block;
}

/* ================================================================ */
.login-home-box a span:nth-child(1) {
  top: 0;
  left: -100%;
  width: 100%;
  height: 2px;
  background: linear-gradient(90deg, transparent, #b8e9ff);
  animation: btn-anim1 2s linear infinite;
  animation-delay: 0;
}

@keyframes btn-anim1 {
  0% {
    left: -100%;
  }
  50%,
  100% {
    left: 100%;
  }
}

.login-home-box a span:nth-child(2) {
  top: -100%;
  right: 0;
  width: 2px;
  height: 100%;
  background: linear-gradient(180deg, transparent, #b8e9ff);
  animation: btn-anim2 2s linear infinite;
  animation-delay: 0.5s;
}

@keyframes btn-anim2 {
  0% {
    top: -100%;
  }
  50%,
  100% {
    top: 100%;
  }
}

.login-home-box a span:nth-child(3) {
  bottom: 0;
  right: -100%;
  width: 100%;
  height: 2px;
  background: linear-gradient(270deg, transparent, #b8e9ff);
  animation: btn-anim3 2s linear infinite;
  animation-delay: 1s;
}

@keyframes btn-anim3 {
  0% {
    right: -100%;
  }
  50%,
  100% {
    right: 100%;
  }
}

.login-home-box a span:nth-child(4) {
  bottom: -100%;
  left: 0;
  width: 2px;
  height: 100%;
  background: linear-gradient(360deg, transparent, #b8e9ff);
  animation: btn-anim4 2s linear infinite;
  animation-delay: 1.5s;
}

@keyframes btn-anim4 {
  0% {
    bottom: -100%;
  }
  50%,
  100% {
    bottom: 100%;
  }
}

.login-home-box a.loading span:nth-child(1) {
  background: linear-gradient(90deg, transparent, #cdc1eb);
  animation: btn-anim1 0.5s linear infinite;
  animation-delay: 0s;
}
.login-home-box a.loading span:nth-child(2) {
  background: linear-gradient(180deg, transparent, #cdc1eb);
  animation: btn-anim2 0.5s linear infinite;
  animation-delay: 0.125s;
}
.login-home-box a.loading span:nth-child(3) {
  background: linear-gradient(270deg, transparent, #cdc1eb);
  animation: btn-anim3 0.5s linear infinite;
  animation-delay: 0.25s;
}
.login-home-box a.loading span:nth-child(4) {
  background: linear-gradient(360deg, transparent, #cdc1eb);
  animation: btn-anim4 0.5s linear infinite;
  animation-delay: 0.375s;
}

.login-home-box .user-box input:-webkit-autofill,
.login-home-box .user-box input:-webkit-autofill:hover,
.login-home-box .user-box input:-webkit-autofill:focus,
.login-home-box .user-box input:-webkit-autofill:active {
  transition-delay: 999999999s;
  transition: background-color 999999999s ease-in-out 0s; /* 因应自动填充给予一个几乎不会发生的过度时间 */
  background-color: inherit !important;
  caret-color: #fff; /* 游标颜色 */
  letter-spacing: 2px;
}
.login-home-box .user-box input:-webkit-autofill {
  -webkit-text-fill-color: #fff !important;
  font-size: 16px;
}
</style>



// WEBPACK FOOTER //
// src/views/login/index.vue